const it = {
  code: "it",
  nav: { book: "Prenota ora", whatsapp: "WhatsApp", menu: "Menu" },
  hero: {
    eyebrow: "Tenerife · Costa sud · Partenze giornaliere",
    lines: ["Le migliori escursioni di Tenerife,", "prenotate in un minuto."],
    sub: "Disponibilità in tempo reale, pagamento immediato e il voucher con QR nella tua casella prima che tu posi il telefono.",
    ctaBook: "Prenota online",
    ctaWa: "Scrivici su WhatsApp",
    trust: ["Cancellazione gratuita", "Conferma immediata", "Voucher con codice QR", "Pagamento sicuro con carta"],
    scroll: "Scorri",
  },
  marquee: ["Disponibilità in tempo reale", "Paghi in meno di un minuto", "Voucher QR via email", "Cancellazione gratuita fino a 24 h", "Equipaggio locale, piccoli gruppi", "4,9 da 2.300 ospiti"],
  trips: {
    eyebrow: "Escursioni di oggi",
    title: "Tre escursioni. Date reali. Nessuna attesa.",
    sub: "Ogni data che vedi è davvero libera. Scegline una, paga e il voucher è già in viaggio.",
    perPerson: "a persona",
    duration: "Durata",
    departs: "Partenza",
    included: "Cosa è incluso",
    pickDate: "Scegli una data",
    people: "Persone",
    total: "Totale",
    pay: "Paga",
    payNow: "Paga e ricevi il voucher",
    free: "Libero",
    few: "Ultimi posti",
    full: "Tutto esaurito",
    spotsLeft: "posti liberi",
    selectDateFirst: "Scegli una data libera per continuare",
    hours: "ore",
    meeting: "Punto d'incontro",
    live: "Disponibilità live",
    items: {
      jetski: {
        title: "Safari in Moto d'Acqua",
        tagline: "Due ore lungo la costa sud sulla tua moto d'acqua, con guida per tutto il percorso.",
        includes: ["Moto d'acqua propria (1–2 persone)", "Guida qualificata e briefing", "Muta, giubbotto e armadietti", "Foto della tua uscita"],
        meeting: "Puerto Colón, Pontile 3",
      },
      catamaran: {
        title: "Catamarano Balene e Delfini",
        tagline: "Tre ore di navigazione con i globicefali residenti, sosta bagno e pranzo a bordo.",
        includes: ["Avvistamento garantito", "Pranzo, bevande e frutta", "Sosta bagno e snorkeling", "Prelievo in hotel nel sud"],
        meeting: "Porto di Los Cristianos, Cancello B",
      },
      teide: {
        title: "Teide: Tramonto e Stelle",
        tagline: "Cinque ore sopra le nuvole: tramonto sul bordo del cratere, poi il cielo con una guida Starlight.",
        includes: ["Minibus climatizzato", "Guida astronomo e telescopi", "Cioccolata calda e coperta", "Prelievo e rientro in hotel"],
        meeting: "Prelievo dal tuo hotel",
      },
    },
  },
  payment: {
    title: "Pagamento sicuro",
    sub: "Paga con carta. Il voucher con codice QR arriva nella tua email appena il pagamento va a buon fine.",
    name: "Nome completo",
    email: "Email per il voucher",
    card: "Numero carta",
    expiry: "Scadenza",
    cvc: "CVC",
    pay: "Paga",
    processing: "Conferma della data in corso…",
    secure: "Crittografia a 256 bit · Protetto da 3-D Secure",
    demo: "Pagamento dimostrativo: nessuna carta verrà addebitata.",
    summary: "Riepilogo ordine",
    error: "Qualcosa è andato storto. Riprova.",
    dateGone: "Quella data è appena andata esaurita. Scegline un'altra.",
    freeCancel: "Cancellazione gratuita fino a 24 ore prima della partenza",
  },
  voucher: {
    eyebrow: "Pagamento confermato",
    title: "Prenotazione fatta.",
    sent: "Il tuo voucher è stato inviato a",
    code: "Codice prenotazione",
    show: "Mostra questo codice QR al punto d'incontro",
    date: "Data",
    time: "Ora",
    people: "Persone",
    paid: "Pagato",
    meeting: "Punto d'incontro",
    download: "Scarica il voucher",
    done: "Fatto",
    bookAnother: "Prenota un'altra escursione",
  },
  how: {
    eyebrow: "Come funziona",
    title: "Tre passi, un minuto.",
    steps: [
      { t: "Scegli una data libera", d: "Il calendario mostra ciò che è davvero disponibile oggi. Se è verde, è tuo." },
      { t: "Paga con carta", d: "Apple Pay, Google Pay o qualsiasi carta. I tuoi posti sono bloccati nell'istante del pagamento." },
      { t: "Arriva il voucher", d: "Un voucher con codice QR arriva subito via email. Mostralo sul telefono e via." },
    ],
  },
  reviews: {
    eyebrow: "Recensioni",
    title: "Cosa dicono al ritorno.",
    items: [
      { name: "Hannah Whitmore", place: "Manchester, Regno Unito", trip: "Safari in Moto d'Acqua", text: "Prenotato a colazione, in acqua alle dieci e mezza. Il voucher è arrivato prima che finissi il caffè. La guida era fantastica e le foto sono incredibili." },
      { name: "Lukas Brandt", place: "Amburgo, Germania", trip: "Catamarano Balene e Delfini", text: "Abbiamo visto i globicefali in venti minuti. Pranzo a bordo, bagno in una baia tranquilla, niente folla. Il check-in con QR ha richiesto tre secondi." },
      { name: "Chiara Moretti", place: "Milano, Italia", trip: "Teide: Tramonto e Stelle", text: "Solo il tramonto sopra le nuvole valeva il viaggio, poi le stelle. La nostra guida sapeva tutto. Il prelievo è stato puntuale al minuto." },
    ],
    verified: "Prenotazione verificata",
  },
  faq: {
    eyebrow: "FAQ",
    title: "Buono a sapersi.",
    items: [
      { q: "Cosa è incluso nel prezzo?", a: "Tutto ciò che è elencato nella scheda: attrezzatura, guida, assicurazione e il cibo o il prelievo indicati. Nessun costo di prenotazione, nessuna sorpresa al punto d'incontro." },
      { q: "Posso cancellare o cambiare data?", a: "Sì. Cancella gratuitamente fino a 24 ore prima della partenza con rimborso totale, oppure sposta la prenotazione su qualsiasi altra data libera con un messaggio su WhatsApp." },
      { q: "Cosa succede se il tempo peggiora?", a: "La sicurezza viene prima di tutto. Se il capitano o la guida annulla per il meteo, scegli tu: nuova data, altra escursione o rimborso completo in giornata. Non perderai mai i tuoi soldi." },
      { q: "Come uso il voucher QR?", a: "Basta mostrarlo sul telefono al punto d'incontro. Niente stampa, niente scartoffie. L'equipaggio lo scansiona e sei a bordo." },
    ],
  },
  footer: {
    tagline: "Escursioni in piccoli gruppi sulla costa sud di Tenerife, organizzate da chi ci vive.",
    contact: "Contatti",
    whatsapp: "Chatta su WhatsApp",
    call: "Chiamaci",
    email: "Email",
    payments: "Accettiamo",
    hours: "Aperto tutti i giorni 08:00 – 21:00",
    built: "Progettato e realizzato da",
    rights: "Tutti i diritti riservati.",
    legal: "Tour operator autorizzato · Registrato a Santa Cruz de Tenerife",
  },
  mobile: { from: "Da", book: "Prenota ora" },
};
export default it;
